/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepostOfRepostNotificationActionData
 */
export interface RepostOfRepostNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof RepostOfRepostNotificationActionData
     */
    type: RepostOfRepostNotificationActionDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RepostOfRepostNotificationActionData
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof RepostOfRepostNotificationActionData
     */
    repostOfRepostItemId: string;
}


/**
 * @export
 */
export const RepostOfRepostNotificationActionDataTypeEnum = {
    Track: 'track',
    Playlist: 'playlist',
    Album: 'album'
} as const;
export type RepostOfRepostNotificationActionDataTypeEnum = typeof RepostOfRepostNotificationActionDataTypeEnum[keyof typeof RepostOfRepostNotificationActionDataTypeEnum];


/**
 * Check if a given object implements the RepostOfRepostNotificationActionData interface.
 */
export function instanceOfRepostOfRepostNotificationActionData(value: object): value is RepostOfRepostNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "repostOfRepostItemId" in value && value["repostOfRepostItemId"] !== undefined;

    return isInstance;
}

export function RepostOfRepostNotificationActionDataFromJSON(json: any): RepostOfRepostNotificationActionData {
    return RepostOfRepostNotificationActionDataFromJSONTyped(json, false);
}

export function RepostOfRepostNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepostOfRepostNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'userId': json['user_id'],
        'repostOfRepostItemId': json['repost_of_repost_item_id'],
    };
}

export function RepostOfRepostNotificationActionDataToJSON(value?: RepostOfRepostNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'user_id': value.userId,
        'repost_of_repost_item_id': value.repostOfRepostItemId,
    };
}

